import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.jsx';
import { startConsentBridge } from './posthog.js';

// PostHog initialisation is deferred until the user grants analytics
// consent through the Termly banner. The bridge listens for Termly's
// consent events and only then calls posthog.init + opt-in.
startConsentBridge();

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV || 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
      // Mask user-typed text and block media in session replays. Interview
      // transcripts, resume content, and the chat input can all contain PII
      // and answers users wouldn't want to expose in a replay — masking by
      // default is the safer compliance posture, especially with an EU /
      // GDPR audience reaching us via the Termly consent flow.
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Sentry.ErrorBoundary fallback={<p style={{padding:'2rem',color:'#fff'}}>Something went wrong. Please refresh the page.</p>}>
    <App />
  </Sentry.ErrorBoundary>
);
